import { gql } from '@apollo/client';

export default gql`
  mutation updateInvoice(
    $_id: String
    $branch: String
    $docNo: String
    $prefix: String
    $title: String
    $time: Date
    $desc: String
    $periodfrom: Date
    $periodto: Date
    $isMonthly: Boolean
    $customer: CustomerInput
    $department: DepartmentInput
    $employee: EmployeeInput
    $project: ProjectInput
    $resourse: ResourseInput
    $contract: ContractInput
    $accounts: [AccountInput]
    $items: String
    $actions: String
    $costAmount: Float
    $total: Float
    $discount: Float
    $amount: Float
    $profit: Float
    $paymentType: String
    $inhand: Float
    $change: Float
    $debitAcc: Int
    $debitAcc2: Int
    $amountPaid2: Float
    $amountPaid: Float
    $payAcc: Int
    $payAcc2: Int
    $tip: Float
    $isPaid: Boolean
    $isCash: Boolean
    $opId: String
    $eventId: Int
    $userId: String
  ) {
    updateInvoice(
      _id: $_id
      branch: $branch
      docNo: $docNo
      prefix: $prefix
      title: $title
      time: $time
      desc: $desc
      periodfrom: $periodfrom
      periodto: $periodto
      isMonthly: $isMonthly
      customer: $customer
      department: $department
      employee: $employee
      project: $project
      resourse: $resourse
      contract: $contract
      accounts: $accounts
      items: $items
      actions: $actions
      costAmount: $costAmount
      total: $total
      discount: $discount
      amount: $amount
      profit: $profit
      paymentType: $paymentType
      inhand: $inhand
      change: $change
      debitAcc: $debitAcc
      debitAcc2: $debitAcc2
      amountPaid2: $amountPaid2
      amountPaid: $amountPaid
      payAcc: $payAcc
      payAcc2: $payAcc2
      tip: $tip
      isPaid: $isPaid
      isCash: $isCash
      opId: $opId
      eventId: $eventId
      userId: $userId
    ) {
      ok
      message
      data
      error
    }
  }
`;
